import Heading from '../../sharedComponents/Heading/Heading';
import './Blogs.scss';
import { ReactComponent as ArrowForward } from '../../../assets/icons/arrow_forward.svg';
import Button from '../../sharedComponents/Button/Button';
import ScrollCarousel from 'scroll-carousel';
import { useEffect, useRef } from 'react';
import CarouselContainer from '../../sharedComponents/Carousel/CarouselContainer';
function Blogs() {
    const carouselRef = useRef(null);

    useEffect(() => {
        if (carouselRef.current) {
            const carousel = new ScrollCarousel(".my-carousel", {
                speed: 15,
                autoplay: true,
                autoplaySpeed: 5,
                smartSpeed: true,
                slideSelector: ".items",
                direction: "rtl",
                margin: 10
            });

            return () => {
                if (carousel && typeof carousel.destroy === 'function') {
                    carousel.destroy();
                }
            };
        }
    }, []);

    const carouselItems = [
        {
            id: 1,
            title: 'First Slide',
            content: 'This is the first slide content'
        },
        {
            id: 2,
            title: 'Second Slide',
            content: 'This is the second slide content'
        },
        {
            id: 3,
            title: 'Third Slide',
            content: 'This is the third slide content'
        },
        {
            id: 4,
            title: 'Fourth Slide',
            content: 'This is the fourth slide content'
        }
    ];
    return (
        <div id='alpha-perceptron-blogs' className='alpha-perceptron-blogs responsiveFlexBox'>
            <div className='alpha-perceptron-blogs__container responsiveFlexBox'>
                <div className='alpha-perceptron-blogs__container__textContainer'>
                    <Heading size='h2' type='primary' theme='dark'>
                        Stay Updated
                    </Heading>
                    <Heading size='h6' type='secondary' theme='dark'>
                        Follow our latest AI breakthroughs, insights, and industry trends
                    </Heading>
                    <Button type='secondary' size='medium' theme='dark' icon={<ArrowForward />}>
                        Read Our Blog
                    </Button>
                </div>

                <div className='alpha-perceptron-blogs__container__carouselContainer'>
                    <div className="my-carousel" ref={carouselRef}>
                        {carouselItems.map(item => (
                            <CarouselContainer className={'items'} content={item.content} title={item.title} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Blogs;

